
import {deliveryApi} from "@/axios";

// 取消发送邮件
export function getSampleInfo(params) {
    return deliveryApi({
        url: '/project/system/samples/info',
        method: 'get',
        params:params
    })
}
